<div class="mt-3 test-case-wrapper container-fluid" [ngStyle]="{ 'height': isGenerating ? '520px' : '480px' }">

  <div class="d-flex justify-content-end w-100" [hidden]="isGenerating">
    <!-- <div class="instruction-box">
      Select Test Cases to Add Test Suite
    </div> -->

    <div class="instruction-box flex-grow-1 general-text-2">
      Test Cases Count: ({{ selectedRow?.length || 0 }})
    </div>

    <div class="d-flex justify-content-end">

      <button class="btn-accello-secondary btn-accello" type="button" (click)="addtestSuite()"
        [disabled]="!selectedRow?.length">
        <img src="assets/images/virtusa-icons/add-icon.svg" alt="add">
        Add To Test Suite ( {{ selectedRow?.length || 0 }} )
      </button>
      <button class="btn-accello-secondary btn-accello mx-2" type="button" (click)="onPublish()"
        [disabled]="!this.feedbackList?.length">
        <img src="assets/images/virtusa-icons/re-gen.svg" alt="re-gen">
        Generate Feedback ({{ this.feedbackList?.length }}) 
        @if(isUpdateFeedback) {
        <span class="spinner-border spinner-border-sm mx-2" role="status" aria-hidden="true"></span>
        }
      </button>

      <button class="btn-accello-secondary btn-accello d-flex justify-content-center" type="button" (click)="onDownload()"
        [disabled]="!selectedRow?.length">
        <img [src]="'assets/images/virtusa-icons/chat-download-purple.svg' | assetUrl" alt="Excel" class="excel-download" />
        Download
      </button>

    </div>
  </div>



  <div class="table-wrapper h-100 mt-2">
    @if(!isGenerating) {
    <ng-container *ngIf="(tableData.data | async)?.length; else noDataTemplate">
      <div class="table-title d-flex flex-column justify-content-center ps-3" *ngIf !="Generated Test Cases">
        <span class="header-5">{{ tableData.headers }}</span>
      </div>
      <!-- <app-zorro-table-tetcase-generator class="w-100" [columns]="tableData.columns" [data]="tableData.data | async"
        (handleActions)="handleTableActions($event)"
        (onRowSelect)="handleRowSelection($event)"></app-zorro-table-tetcase-generator> -->
        <app-test-case-table
        class="w-100"
        [configs]="tableConfigs"
        (onRowSelect)="handleRowSelection($event)"
        (handleActions)="handleSidePanelActions($event)"
        [isTestCase]="true"
        ></app-test-case-table>
    </ng-container>
    <ng-template #noDataTemplate>
      <ng-container *ngIf="!(tableData.data | async)?.length">
        <app-no-data></app-no-data>
      </ng-container>
    </ng-template>
    } @else {
    <div class="h-100 v-center w-50 mx-auto position-relative">
      <div style="width: 100%; height: 100%;" *ngIf="!tableConfigs?.rows?.length && isLoading">
        <app-loading></app-loading>
      </div>
      <app-progress-bar *ngIf="!isLoading" [text]="progress.text" [progress]="progress.percentage" [isError]="progress.isError"></app-progress-bar>
      <!-- <div *ngIf="percentage === 100" class="position-absolute top-55">
        <img src="assets/images/tick-green.png" alt="tick" class="tick-icon" />
        <span class="mx-1 message-text-progress">
          Testcase Generated Successfully
        </span>
      </div> -->
    </div>
    }
  </div>
  <!-- <div class="mt-3 d-flex justify-content-end"> -->
  <!-- <button
      class="btn-accello-primary btn-accello"
      type="button"
      [disabled]="!(tableData.data | async)?.length"
    >
      Add Missing Test cases
    </button> -->

  <!-- </div> -->
</div>